import React from "react";
import { FaSpinner } from "react-icons/fa";

const LoadingSpinner = ({ 
  size = "md", 
  text = "Loading...", 
  fullScreen = false,
  className = "" 
}) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  const spinner = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <FaSpinner 
        className={`${sizeClasses[size]} animate-spin text-brand-600 mb-2`} 
      />
      {text && (
        <p className="text-sm text-slate-600 animate-pulse">{text}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;

